module.exports = "<i class=\"fa fa-warning system-status-warning\" title={{value}}></i>";